import React, {useEffect, useState} from 'react'
import {Routes, Route, Navigate, Outlet, useParams} from 'react-router-dom'
import SettingWrapper from './SettingWrapper'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import Subscription from './Subscription'

const profileBreadCrumbs: Array<PageLink> = [
  {title: 'Setting Details', path: '/Subscription', isSeparator: false, isActive: false},
  {title: '', path: '', isSeparator: true, isActive: false},
]

const SettingsRoute = () => {
  let userType = localStorage.getItem('user_type')
  return (
    <>
      <Routes>
        {/* Begin: main route for setting */}
        <Route
          element={
            <>
              <SettingWrapper />
              <Outlet />
            </>
          }
        >
          {/* End: Child route for subscription */}
          {userType === 'Non-Tenant' && (
            <Route
              path='subscription'
              element={
                <>
                  <PageTitle breadcrumbs={profileBreadCrumbs}>Subscription</PageTitle>
                  <Subscription />
                </>
              }
            />
          )}
          {/* End: Child route for subscription */}
        </Route>
        <Route path='*' element={<Navigate to='/404' />} />
        {/* End: main route for setting */}
      </Routes>
    </>
  )
}

export default SettingsRoute
